import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentFirstRealBlockIndex({ content }: Props) {
  let firstRealBlockIndex;

  content.contentBlocks.forEach((block, i) => {
    if (!firstRealBlockIndex && block.type !== 'SCROLL_TRACKING') {
      firstRealBlockIndex = i;
    }
  });

  return firstRealBlockIndex;
}
